import { useMutation, useQuery } from '@tanstack/react-query';
import fitStudioRequest from '../utils/request';

const legacyOtaServices = {
  useQueryGetOtaVersions({ environment, active }, onSuccess) {
    return useQuery(
      ['get-legacy-ota-versions', { environment, active }],
      async ({ queryKey }) => {
        try {
          const res = await fitStudioRequest.get('/legacy-app-ota', {
            params: {
              ...(queryKey[1].environment &&
                queryKey[1].environment !== 'all' && {
                  environment: queryKey[1].environment,
                }),
              ...(typeof queryKey[1].active === 'boolean' && {
                active: queryKey[1].active,
              }),
            },
          });

          return res.data;
        } catch (error) {
          throw error?.response?.data?.message ?? error.message;
        }
      },
      {
        onSuccess,
        refetchOnWindowFocus: false,
      }
    );
  },

  useQueryGetUpdateJson({ environment, appVersion, buildNumber }, onSuccess) {
    return useQuery(
      ['get-legacy-ota-update-json', { environment, appVersion, buildNumber }],
      async ({ queryKey }) => {
        try {
          const res = await fitStudioRequest.get(
            '/legacy-app-ota/update.json',
            {
              params: {
                environment: queryKey[1].environment,
                appVersion: queryKey[1].appVersion,
                buildNumber: queryKey[1].buildNumber,
              },
            }
          );

          return res.data;
        } catch (error) {
          throw error?.response?.data?.message ?? error.message;
        }
      },
      {
        enabled:
          !!environment && !!appVersion && typeof buildNumber === 'number',
        onSuccess,
        refetchOnWindowFocus: false,
      }
    );
  },

  useMutationCreateOtaVersion(onSuccess, onError) {
    return useMutation({
      mutationFn: async (formData) => {
        try {
          const res = await fitStudioRequest.post(
            '/legacy-app-ota',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            }
          );

          return res.data.data;
        } catch (error) {
          throw error?.response?.data?.message ?? error.message;
        }
      },
      onSuccess,
      onError,
    });
  },

  useMutationUpdateOtaVersion(onSuccess, onError) {
    return useMutation({
      mutationFn: async ({ id, formData }) => {
        try {
          const res = await fitStudioRequest.patch(
            `/legacy-app-ota/${id}`,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            }
          );

          return res.data.data;
        } catch (error) {
          throw error?.response?.data?.message ?? error.message;
        }
      },
      onSuccess,
      onError,
    });
  },

  useMutationToggleOtaActive(onSuccess, onError) {
    return useMutation({
      mutationFn: async ({ id, active }) => {
        try {
          const res = await fitStudioRequest.patch(
            `/legacy-app-ota/${id}/active`,
            { active }
          );

          return res.data.data;
        } catch (error) {
          throw error?.response?.data?.message ?? error.message;
        }
      },
      onSuccess,
      onError,
    });
  },

  useMutationDeleteOta(onSuccess, onError) {
    return useMutation({
      mutationFn: async ({ id, force }) => {
        try {
          const res = await fitStudioRequest.delete(`/legacy-app-ota/${id}`, {
            params: force ? { force: 'true' } : undefined,
          });

          return res.data.data;
        } catch (error) {
          throw error?.response?.data?.message ?? error.message;
        }
      },
      onSuccess,
      onError,
    });
  },
};

export default legacyOtaServices;
